import path from 'path';
import fs from 'fs-extra';
import { fileURLToPath } from 'url';

const __filename = fileURLToPath(import.meta.url);
const __dirname = path.dirname(__filename);

export async function copyTemplate(templateType: string, targetDir: string) {
  const templateDir = path.join(__dirname, '../../templates', templateType);
  
  if (!await fs.pathExists(templateDir)) {
    throw new Error(`Template directory not found: ${templateType}`);
  }
  
  // Copy all template files to target directory
  await fs.copy(templateDir, targetDir, {
    overwrite: true,
    filter: (src) => {
      // Skip .git directories and other unwanted files
      return !src.includes('.git') && !src.includes('node_modules');
    }
  });
  
  console.log(`📁 Template files copied from ${templateType}`);
}